import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { AgentEntity, CreateAgentDto, UpdateAgentDto } from '@tradecafe/aiagent-sdk';
import type { AccountObject, User } from '@tradecafe/types/core';
import type { DeepReadonly } from '@tradecafe/types/utils';
import { environment } from 'src/environments/environment';


const { apiUrl } = environment


@Injectable()
export class AgentApiService {
  private readonly http = inject(HttpClient)


  list() {
    return this.http.get<{ data: { agents: AgentEntity[], users: User[], accounts: AccountObject[] } }>(`${apiUrl}/ai/agent`)
  }

  create(data: DeepReadonly<Omit<CreateAgentDto, 'created_by'>>) {
    return this.http.post<{ data: AgentEntity }>(`${apiUrl}/ai/agent`, data)
  }

  get(id: string) {
    return this.http.get<{ data: AgentEntity }>(`${apiUrl}/ai/agent/${id}`)
  }

  update(id: string, data: DeepReadonly<Omit<UpdateAgentDto, 'updated_by'>>) {
    return this.http.put<{ data: AgentEntity }>(`${apiUrl}/ai/agent/${id}`, data)
  }

  delete(id: string) {
    return this.http.delete<{ data: AgentEntity }>(`${apiUrl}/ai/agent/${id}`)
  }
}
